<div class="content-heading">
  <div class="header-container">
    <h3>Reporte de Altas y Bajas de Equipo</h3>
    <small>Reporte Web</small>
  </div>
</div>

<div class="container-fluid">
  <div class="row">
    <div class="col-lg-12">
      <div class="card card-default">
        <div class="card-body">
          <div id="RECSEG">
            <div class="row filter-container">
              <div class="col-sm-4">
                <span>Organizaci&oacute;n</span>
                  <select class="form-control" [(ngModel)]="organizationSelected"
                          name="RegionNameOri" required [disabled]="working" title="Organización"
                          (ngModelChange)="getRegion()">
                    <!--<option [value]="0" selected>Todos</option>-->
                    <option *ngFor="let unit of organizacionList" [value]="unit.UnitId">{{unit.UnitDescription}}</option>
                  </select>
              </div>
              <div class="col-sm-4">
                <span>Regi&oacute;n</span>
                  <select class="form-control" [(ngModel)]="regionSelected"
                          name="RegionNameOri" required [disabled]="working" title="Región"
                          (ngModelChange)="getNodes()">
                    <option [value]=0 selected>TODOS</option>
                    <option *ngFor="let unit of region" [value]="unit.UnitId">{{unit.UnitDescription}}</option>
                  </select>
              </div>
              <div class="col-sm-4">
                <span>Nodo</span>
                  <ng-autocomplete
                    [placeholder]="'Búsqueda'"
                    [disabled]="working"
                    [data]="nodesUser"
                    [searchKeyword]="inputKeyword"
                    [itemTemplate]="itemInputTemplate"
                    [notFoundTemplate]="notFoundinputTemplate"
                    [debounceTime]="600"
                    [minQueryLength]="3"
                    (selected)='changeNode($event)'
                    (inputCleared)="clearNode()"
                    [(ngModel)]="selectedNodeName"
                  >
                  </ng-autocomplete>
                  <ng-template #itemInputTemplate let-item>
                    <a [innerHTML]="item.UnitDescription"></a>
                  </ng-template>
                  <ng-template #notFoundinputTemplate let-notFound>
                    <div [innerHTML]="'No se encontraron coincidencias'"></div>
                  </ng-template>
              </div>
            </div>
            <div class="row filter-container">
              <div class="col-sm-6">
                <span>Tipo</span>

                <app-ceq-multiselect [Items]="typeList" 
                                (shareCheckedList)="onTypeFilterChange($event)"
                                (shareIndividualCheckedList)="ontypeItemCheckedChange($event)"
                               ></app-ceq-multiselect>
              </div>
              <div class="col-sm-6">
                <span>Equipo</span>
                <app-ceq-multiselect [Items]="itemsList" 
                (shareCheckedList)="onItemsFilterChange($event)"
                (shareIndividualCheckedList)="onItemsItemCheckedChange($event)"
               ></app-ceq-multiselect>
               
              </div>
            </div>

            <div class="row filter-container">
              <div class="col-sm-6">
                <span>Desde</span>
                <input [disabled]="working"
                       type="date"
                       class="form-control"
                       [(ngModel)]="desde"/>


              </div>
              <div class="col-sm-6">
                <span>Hasta</span>
                <input [disabled]="working"
                       type="date"
                       class="form-control"
                       [(ngModel)]="hasta" />
              </div>
            </div>

            <br>
            <div class="row mt-3 col-lg-12 col-md-12">
              <!--Buttons-->
              <button class="mr-1  btn btn-labeled btn-outline-success mb-2" [disabled]="downloading" (click)="download()">
                <span class="btn-label">
                <i class="fa fa-file-excel" aria-hidden="true" *ngIf="!downloading" style="font-size: 1.5em;"></i>
                <i class="fa fa-circle-notch fa-spin" *ngIf="downloading" style="font-size: 1.5em;"></i>
                </span>
                <span>Descargar reporte</span>                
              </button>
            </div>
          </div>
          </div>
        </div>
    </div>
  </div>
</div>


